import { withDefaults } from '@warp-drive/legacy/model/migration-support';

// API resource: tio-api app/resources/api/v1/limit_ledger_entry_resource.rb
const LimitLedgerEntrySchema = withDefaults({
  type: 'limit-ledger-entry',
  fields: [
    { kind: 'attribute', name: 'product' },
    { kind: 'attribute', name: 'batch' },
    { kind: 'attribute', name: 'scheme' },
    { kind: 'attribute', name: 'amount' },
    { kind: 'attribute', name: 'group' },
    { kind: 'attribute', name: 'itemType' },
    { kind: 'attribute', name: 'itemId' },
    { kind: 'attribute', name: 'period' },
    { kind: 'attribute', name: 'entryDate' },
    { kind: 'attribute', name: 'effectiveDate' },
    { kind: 'attribute', name: 'details' },
    { kind: 'attribute', name: 'description' },
    {
      kind: 'belongsTo',
      name: 'dependent',
      type: 'dependent',
      options: { async: false, inverse: null },
    },
    {
      kind: 'belongsTo',
      name: 'employee',
      type: 'employee',
      options: { async: false, inverse: null },
    },
    {
      kind: 'belongsTo',
      name: 'company',
      type: 'company',
      options: { async: false, inverse: null },
    },
  ],
});

export default LimitLedgerEntrySchema;
